var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [_vm.$style["mds-page-shell"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c("div", { class: _vm.$style["mds-page-shell__header"] }, [
        _c("div", { class: _vm.$style["mds-page-shell__skip-links"] }, [
          _c(
            "a",
            {
              class: _vm.$style["mds-page-shell__skip-link"],
              attrs: { href: "#mds-page-shell-content" },
            },
            [_vm._v(" " + _vm._s(_vm.skipNavigationText) + " ")]
          ),
        ]),
        _c("header", { class: _vm.$style["mds-page-shell__masthead"] }, [
          _c(
            "div",
            { class: _vm.$style["mds-page-shell__masthead-left"] },
            [
              _vm.hiddenMenu
                ? [
                    _c("mds-button", {
                      class: [
                        _vm.$style["mds-masthead--hide-wide"],
                        _vm.$style["mds-page-shell__menu-button--responsive"],
                      ],
                      attrs: {
                        variation: "icon-only",
                        icon: "menu",
                        text: _vm.menuText,
                        type: "button",
                        "aria-haspopup": "true",
                        "aria-expanded": _vm.navigationActive
                          ? "true"
                          : "false",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showHiddenNav()
                        },
                      },
                    }),
                    !_vm.hiddenMenuHideWide
                      ? _c("mds-button", {
                          class: [
                            _vm.$style["mds-masthead--show-wide"],
                            _vm.$style["mds-page-shell__menu-button"],
                          ],
                          attrs: {
                            variation: "flat",
                            "flat-button-icon-size": "medium",
                            icon: "menu",
                            text: _vm.menuText,
                            type: "button",
                            "aria-haspopup": "true",
                            "aria-expanded": _vm.navigationActive
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showHiddenNav()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._t("mds-page-shell-masthead-left"),
            ],
            2
          ),
          _c(
            "div",
            { class: _vm.$style["mds-page-shell__masthead-logo-wrap"] },
            [
              _vm.logoHref || _vm.isRoutable
                ? _c(
                    _vm.componentType,
                    _vm._b(
                      {
                        tag: "component",
                        class: _vm.$style["mds-page-shell__masthead-link"],
                        attrs: { href: _vm.logoHref },
                      },
                      "component",
                      _vm.routingProps,
                      false
                    ),
                    [
                      _c("img", {
                        class: _vm.$style["mds-page-shell__masthead-logo-wide"],
                        attrs: { src: _vm.logo, alt: _vm.logoAlt },
                      }),
                      _c("img", {
                        class: _vm.$style["mds-page-shell__masthead-logo"],
                        attrs: { src: _vm.logoResponsive, alt: _vm.logoAlt },
                      }),
                    ]
                  )
                : [
                    _c("img", {
                      class: _vm.$style["mds-page-shell__masthead-logo-wide"],
                      attrs: { src: _vm.logo, alt: _vm.logoAlt },
                    }),
                    _c("img", {
                      class: _vm.$style["mds-page-shell__masthead-logo"],
                      attrs: { src: _vm.logoResponsive, alt: _vm.logoAlt },
                    }),
                  ],
            ],
            2
          ),
          _c(
            "div",
            { class: _vm.$style["mds-page-shell__masthead-right"] },
            [_vm._t("mds-page-shell-masthead-right")],
            2
          ),
        ]),
        _vm.$slots["mds-page-shell-horizontal-nav"]
          ? _c(
              "div",
              { class: _vm.$style["mds-page-shell__horizontal-nav"] },
              [_vm._t("mds-page-shell-horizontal-nav")],
              2
            )
          : _vm._e(),
      ]),
      _c("div", { class: _vm.$style["mds-page-shell__body"] }, [
        _vm.$slots["mds-page-shell-vertical-nav"]
          ? _c(
              "div",
              {
                ref: "verticalNav",
                class: _vm.$style["mds-page-shell__vertical-nav"],
              },
              [_vm._t("mds-page-shell-vertical-nav")],
              2
            )
          : _vm._e(),
        _c(
          "main",
          {
            class: _vm.$style["mds-page-shell__content"],
            attrs: { id: "mds-page-shell-content" },
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm.$slots["mds-page-shell-hidden-nav"]
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "overlay",
                  rawName: "v-overlay:[{value:navigationActive,class:classes}]",
                  value: _vm.hideHiddenNav,
                  expression: "hideHiddenNav",
                  arg: { value: _vm.navigationActive, class: _vm.classes },
                },
              ],
              ref: "hiddenNav",
              class: _vm.$style["mds-page-shell__hidden-nav-container"],
              attrs: { "aria-hidden": _vm.navigationActive ? "false" : "true" },
            },
            [
              _c(
                "div",
                {
                  class:
                    _vm.$style["mds-page-shell__hidden-nav-container-inner"],
                },
                [
                  _c(
                    "div",
                    { class: _vm.$style["mds-page-shell__hidden-nav"] },
                    [_vm._t("mds-page-shell-hidden-nav")],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }